import React, { useState } from "react";
import Layout from ".././HorizontalMenu/Menu";
import Navbar from ".././HorizontalMenu/Navbar";
import {
    Container,
    Row,
    Col,
    Label,
    Card,
    CardHeader,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../index";
import CIIAssessmentPartial from "./partials/CIIAssessmentPartial";
import { setVesselID } from "../Store/Generic/ReportingSlice";
import classnames from "classnames";
import STSAdjustmentPartial from "./partials/STSAdjustmentPartial";
import { VesselTypeConstant } from "shared/constants";
import N2CorrectionPartial from "./partials/N2CorrectionPartial";
import VoyageAdjustmentPartial from "./partials/VoyageAdjustmentPartial";
import VesselDetailsHeader from "Components/VesselDetailsHeader";
import { customStyle } from "shared/CommonCSS";
import { loadLastUpdatedOn } from "VesselMaster/vesselMaster.hooks";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import FCeboAdjustmentPartial from "./partials/FCeboAdjustmentPartial";

const CIIAssessment = () => {
    /** State varibles */
    const [activeSettingsTab, setActiveSettingsTab] = useState("1");
    const dispatch = useDispatch();
    const { Vessels, VesselID } = useSelector(
        (state: RootState) => state.Reporting
    );
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);
    /** State variables end */

    /** Queries */
    /** Last report which is sent's date */
    const {
        data: UpdatedDate,
        isLoading: UpdatedDateLoading,
        isError: UpdatedDateError,
    } = useQuery(
        [queryKeyes.vessel.LastUpdatedOn.key, VesselID],
        async () => {
            return await loadLastUpdatedOn(VesselID);
        },
        { staleTime: Infinity }
    );
    /** Queries end */

    /** Function to switch tabs */
    const toggle = (tab: any) => {
        if (activeSettingsTab !== tab) {
            setActiveSettingsTab(tab);
        }
    };

    /** Function for global vessel selection */
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e.id));
    };

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <Row className="mb-3">
                        <Col sm={4}>
                            <Label className="mb-0">Select vessel</Label>
                            <Select
                                options={
                                    Vessels.filter((item: any) => item.display === true) as any[]
                                }
                                getOptionLabel={(option: any) => option.vessel_name}
                                getOptionValue={(option: any) => option.id}
                                onChange={(e: any) => handleVesselSelectionChanges(e)}
                                menuPortalTarget={document.body}
                                styles={customStyle}
                                defaultValue={{
                                    id: VesselID,
                                    vessel_name: vessel?.vessel_name,
                                }}
                            />
                        </Col>
                        <Col sm={8} className="pt-3 text-end">
                            <div className="d-inline-block">
                                <h3 className="m-0">CII Assessment</h3>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {!UpdatedDateLoading && !UpdatedDateError && (
                            <Col sm={3} className="d-flex align-items-end pr-0">
                                <p className="mb-0">
                                    Last updated on:
                                    <strong>
                                        {" "}
                                        {UpdatedDate?.date?.toString().substring(0, 10)}
                                    </strong>
                                </p>
                            </Col>
                        )}
                        <Col sm={8}>
                            <VesselDetailsHeader />
                        </Col>
                    </Row>
                    <Card>
                        <CardHeader className="pb-0">
                            <Nav tabs className="border-0">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                        }}
                                    >
                                        CII Assessment
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                        }}
                                    >
                                        Voyage Adjustment
                                    </NavLink>
                                </NavItem>
                                {vessel?.vessel_type === VesselTypeConstant.TANKER && (
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeSettingsTab === "3",
                                            })}
                                            onClick={() => {
                                                toggle("3");
                                            }}
                                        >
                                            STS Adjustment
                                        </NavLink>
                                    </NavItem>
                                )}
                                {vessel?.vessel_type === VesselTypeConstant.LNG_CARRIER && (
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeSettingsTab === "4",
                                            })}
                                            onClick={() => {
                                                toggle("4");
                                            }}
                                        >
                                            N<sub>2</sub> Correction
                                        </NavLink>
                                    </NavItem>
                                )}
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "5",
                                        })}
                                        onClick={() => {
                                            toggle("5");
                                        }}
                                    >
                                        FC<sub>(elec + boiler + other)</sub> Adjustment
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </CardHeader>
                        <TabContent activeTab={activeSettingsTab}>
                            <TabPane tabId="1" className="margin-3">
                                {VesselID > 0 && <CIIAssessmentPartial vesselId={VesselID} />}
                            </TabPane>
                            <TabPane tabId="2" className="margin-3">
                                <VoyageAdjustmentPartial />
                            </TabPane>
                            <TabPane tabId="3" className="margin-3">
                                <STSAdjustmentPartial />
                            </TabPane>
                            <TabPane tabId="4" className="margin-3">
                                <N2CorrectionPartial />
                            </TabPane>
                            <TabPane tabId="5" className="margin-3">
                                <FCeboAdjustmentPartial />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default CIIAssessment;
